'use strict';

module.exports = 60 * 1000;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/var/MINUTES.js
// module id = 314
// module chunks = 0